var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.75L24.6667 21.5833L22.5083 19.425L20.0417 21.8917V15.4167H16.9583V21.8917L14.4917 19.425L12.3333 21.5833L18.5 27.75ZM7.70834 12.3333V29.2917H29.2917V12.3333H7.70834ZM7.70834 32.375C6.86042 32.375 6.13429 32.0728 5.52996 31.4685C4.92563 30.8642 4.62397 30.1386 4.625 29.2917V10.0594C4.625 9.69966 4.68307 9.35279 4.79921 9.01876C4.91535 8.68473 5.08853 8.3764 5.31875 8.09376L7.24584 5.74272C7.52847 5.38299 7.88152 5.10652 8.30496 4.9133C8.72841 4.72008 9.17189 4.62398 9.63542 4.62501H27.3646C27.8271 4.62501 28.2706 4.72162 28.695 4.91484C29.1195 5.10806 29.4726 5.38402 29.7542 5.74272L31.6813 8.09376C31.9125 8.3764 32.0862 8.68473 32.2023 9.01876C32.3185 9.35279 32.376 9.69966 32.375 10.0594V29.2917C32.375 30.1396 32.0728 30.8657 31.4685 31.4701C30.8642 32.0744 30.1386 32.376 29.2917 32.375H7.70834ZM8.325 9.25001H28.675L27.3646 7.70834H9.63542L8.325 9.25001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateWhite);
export default __webpack_public_path__ + "static/media/deactivate-white.89666d225b571dcfae6c40b9a1c144f7.svg";
export { ForwardRef as ReactComponent };